/* used to define the routes for custom router navigation inside pages and components */
export const AppPages = {
  Folders: 'folders',
  Login: 'login',
  News: 'news',
  NotFoundPage: '404',
  ServerErrorPage: '503',
  UsersProfile: '/users/profile'
};
